import React from 'react';
import type { AddDocumentDialogProps } from './AddDocumentDialogContent';
import dynamic from 'next/dynamic';
import { DynamicDialogLoader } from '../common';

const AddDocumentDialogContent = dynamic<AddDocumentDialogProps>(
  () =>
    import('./AddDocumentDialogContent').then(
      (mod) => mod.AddDocumentDialogContent
    ),
  {
    ssr: false,
    loading: DynamicDialogLoader
  }
);

export function AddDocumentDialog({ pendingDocument }: AddDocumentDialogProps) {
  return <AddDocumentDialogContent pendingDocument={pendingDocument} />;
}
